import { render, staticRenderFns } from "./CustomDiv.vue?vue&type=template&id=014aacb1&scoped=true&lang=pug&"
import script from "./CustomDiv.vue?vue&type=script&lang=js&"
export * from "./CustomDiv.vue?vue&type=script&lang=js&"
import style0 from "./CustomDiv.vue?vue&type=style&index=0&id=014aacb1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014aacb1",
  null
  
)

export default component.exports